import { FC } from "react";
import ForgotPasswordForm from "../../components/Form/ForgotPassword";

const ForgotPasswordPage: FC = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;
